module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/flash/flash-coupons/flash-coupons.component.css
// module id = ./src/app/components/flash/flash-coupons/flash-coupons.component.css
// module chunks = main